import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ParagraphTextService } from './service/paragraph-text-service';
import { ParagraphTextServiceImpl } from './service/impls/paragraph-text-service';
import { SplitEditorModel } from './models/split-editor-model';
import { SplitEditorModelImpl } from './models/impls/split-editor-model';

export const spiltEditorServiceModule = new ContainerModule((bind) => {
    bind(ParagraphTextService).to(ParagraphTextServiceImpl);
    bind(SplitEditorModel).to(SplitEditorModelImpl);
});
